import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BusinessContext = createContext();

export const useBusinessInfo = () => {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error('useBusinessInfo must be used within a BusinessProvider');
  }
  return context;
};

export const BusinessProvider = ({ children }) => {
  const [businessInfo, setBusinessInfo] = useState({
    phone: '+52 33 1196 0842',
    address: 'Mazamitla, Jalisco, México',
    check_in_time: '15:00',
    check_out_time: '12:00',
    bank_name: '',
    bank_account: '',
    bank_clabe: '',
    bank_account_holder: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const response = await axios.get(`${API}/business-info`);
        if (response.data) {
          // Map backend fields to our state structure
          const data = response.data;
          setBusinessInfo(prev => ({
            ...prev,
            phone: data.whatsapp || prev.phone,
            address: data.address || prev.address,
            check_in_time: data.check_in_time || prev.check_in_time,
            check_out_time: data.check_out_time || prev.check_out_time,
            bank_name: data.bank_info?.bank_name || '',
            bank_clabe: data.bank_info?.clabe || '',
            bank_account_holder: data.bank_info?.account_holder || ''
          }));
        }
      } catch (error) {
        console.error('Error fetching business info:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBusinessInfo();
  }, []);

  // Format phone for WhatsApp link (remove spaces and special chars)
  const getWhatsAppLink = (message = '') => {
    const cleanPhone = businessInfo.phone.replace(/[\s\-\(\)]/g, '').replace('+', '');
    if (message) {
      return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
    }
    return `https://wa.me/${cleanPhone}`;
  };

  const value = {
    businessInfo,
    loading,
    getWhatsAppLink,
    phone: businessInfo.phone,
    address: businessInfo.address,
    checkInTime: businessInfo.check_in_time,
    checkOutTime: businessInfo.check_out_time
  };

  return (
    <BusinessContext.Provider value={value}>
      {children}
    </BusinessContext.Provider>
  );
};

export default BusinessContext;
